import { pricingStructureDisplayName } from "src/main/Billing/helpers"

export const HIN_REGEX =
  /^([A-Za-z]{2}-?)?[A-Za-z]{3}[A-HJ-NPRa-hj-nprS-Zs-z0-9]{5}([A-La-l][0-9]{3}|[0-9]{4}|[Mm][0-9]{2}[A-La-l])$/

export const toPricingStructureSelectOptions = (items) =>
  items.map((value) => ({ value, label: pricingStructureDisplayName(value) }))

export const getRateFields = (
  pricingStructureSelectOptions,
  { includeTax }
) => {
  const requiredTogether = includeTax
    ? ["rate", "pricing_structure", "tax"]
    : ["rate", "pricing_structure"]

  const errorMessage = includeTax
    ? "Rate, Tax, and Pricing Structure must all be provided together or all left blank"
    : "Rate and Pricing Structure must be provided together or both left blank"

  const buildValidator = (key) => ({
    validate: "require_with",
    fields: requiredTogether.filter((f) => f !== key),
    errorMessage,
  })

  const rateFields = [
    {
      label: "Rate",
      key: "rate",
      type: ["number", { preset: "usd" }],
      description:
        "Rate amount in dollars. Provide all rate fields or leave all blank to inherit from contract group.",
      validators: [buildValidator("rate")],
    },
    {
      label: "Pricing Structure",
      key: "pricing_structure",
      type: "select",
      selectOptions: pricingStructureSelectOptions,
      validators: [buildValidator("pricing_structure")],
    },
  ]

  if (includeTax) {
    rateFields.push({
      label: "Tax",
      key: "tax",
      type: ["number", { preset: "percent", min: 0, max: 1 }],
      description: "Tax rate as decimal (e.g., enter 0.075 for 7.5%)",
      validators: [buildValidator("tax")],
    })
  }

  return rateFields
}

export const addressFields = {
  address_line_one: {
    label: "Address Line 1",
    key: "address_line_one",
    type: "string",
  },
  address_line_two: {
    label: "Address Line 2",
    key: "address_line_two",
    type: "string",
  },
  city: {
    label: "City",
    key: "city",
    type: "string",
  },
  state: {
    label: "State",
    key: "state",
    type: "string",
  },
  zip: {
    label: "Zip",
    key: "zip",
    type: "string",
  },
}

export const contactFields = {
  name: {
    label: "Full Name",
    key: "name",
    type: "string",
    description: "Contact's full name",
    validators: [{ validate: "required" }],
  },
  email: {
    label: "Email",
    key: "email",
    type: "email",
    description: "Contact's email address",
    validators: [{ validate: "required" }],
  },
  phone: {
    label: "Phone",
    key: "phone",
    type: ["phone-number", { country: "US", format: "both" }],
    description: "Contact's phone number",
  },
  customer_notes: {
    label: "Customer Notes",
    key: "customer_notes",
    type: "string",
  },
}

export const getBoatFields = (boatTypes) => {
  return {
    boatName: {
      label: "Boat Name",
      key: "boat_name",
      type: "string",
    },
    boatType: {
      label: "Boat Type",
      key: "boat_type",
      type: "select",
      selectOptions: boatTypes,
    },
    measurementUnit: {
      label: "Measurement Unit",
      key: "measurement_unit",
      type: "select",
      description: "Unit for LOA, Beam, Draft, and Height",
      selectOptions: [
        { value: "feet", label: "Feet" },
        { value: "inches", label: "Inches" },
      ],
    },
    lengthOverall: {
      label: "LOA",
      key: "length_overall",
      type: "number",
      description: "Length overall",
    },
    beam: {
      label: "Beam",
      key: "beam",
      type: "number",
      description: "Beam width",
    },
    draft: {
      label: "Draft",
      key: "draft",
      type: "number",
      description: "Draft depth",
    },
    height: {
      label: "Height",
      key: "height",
      type: "number",
      description: "Height",
    },
    year: {
      label: "Year",
      key: "year",
      type: "string",
    },
    make: {
      label: "Make",
      key: "make",
      type: "string",
    },
    model: {
      label: "Model",
      key: "model",
      type: "string",
    },
    hailingPort: {
      label: "Hailing Port",
      key: "hailing_port",
      type: "string",
    },
    hullId: {
      label: "Hull ID (HIN)",
      key: "hull_identification",
      type: "string",
      validators: [
        {
          validate: "regex_match",
          regex: HIN_REGEX,
          errorMessage:
            "Format does not appear to be valid. Please double-check your entry.",
        },
      ],
    },
    registrationNumber: {
      label: "Registration Number",
      key: "registration_number",
      type: "string",
    },
    registrationExpirationDate: {
      label: "Registration Expiration Date",
      key: "registration_expiration_date",
      type: "date",
    },
    insurancePolicyNumber: {
      label: "Insurance Policy Number",
      key: "insurance_policy_number",
      type: "string",
    },
    insuranceExpirationDate: {
      label: "Insurance Expiration Date",
      key: "insurance_expiration_date",
      type: "date",
    },
    insuranceCompany: {
      label: "Insurance Company",
      key: "insurance_company",
      type: "string",
    },
  }
}
